import type { FC, SelectHTMLAttributes } from 'react';

import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@shared/components/ui';
import { cn } from '@shared/utils';

interface SelectOption {
  value: string;
  label: string;
}

export interface GenericSelectProps extends Omit<SelectHTMLAttributes<HTMLSelectElement>, 'onChange'> {
  options: SelectOption[];
  value?: string;
  placeholder?: string;
  onChange: (value: string) => void;
  onClose?: () => void;
}

export const GenericSelect: FC<GenericSelectProps> = ({
  options,
  value,
  onChange,
  placeholder = 'Select an option',
  disabled,
  className,
  onClose,
}) => {
  const handleOpenChange = (open: boolean) => {
    if (!open && onClose) onClose();
  };
  return (
    <Select value={value} onValueChange={onChange} disabled={disabled} onOpenChange={handleOpenChange}>
      <SelectTrigger className={cn('w-full', className)}>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>

      <SelectContent>
        {options.map((option) => (
          <SelectItem key={option.value} value={option.value} className="cursor-pointer">
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
